<template>
    <ModalComponent
        name="avisoConfGeneral"
        title="¿Estás seguro de que quieres guardar la configuración?"
        @close="close(false)"
    >
        <div class="row">
            <div class="col-12 text-center alert alert-danger">
                <span>Estos cambios sobreescribirán la configuración de <strong>TODOS</strong> los precios</span>
            </div>
            <div class="col-12 text-center">
                <Button class="text-right" type="button" name="button" @click.prevent="close(true)">Guardar precios</Button>
            </div>
        </div>
        
    </ModalComponent>        
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        methods: {
            close(confirmar) {
                this.$emit('close', 'avisoConfGeneral', confirmar);
            }
        },
        components: { ModalComponent }
    }
</script>